import { onBeforeUnmount, onMounted } from 'vue'
import { showBackButton } from '@/telegramWebApp'

// Shows Telegram's native back button while the calling page is mounted. Outside Telegram this
// is a no-op -- pages keep their own in-page back link for plain browsers.
export function useBackButton(onBack: () => void): void {
  let hide: (() => void) | null = null
  onMounted(() => {
    hide = showBackButton(onBack)
  })
  onBeforeUnmount(() => hide?.())
}
